//
//
//
//
//
//
//

import Components from '@/components/dynamicComponent'

export default {
  components: {
    Components
  },
  data() {
    return {
      page: [],
      error: null
    }
  },
  computed: {
    d () {
      const slug = this.$route.params.slug;
      return this.$store.getters.posts[slug]
    }
  },
  async asyncData({
    params,
    error,
    store
  }) {
    try {
      await store.dispatch('getPosts', params.slug)
    } catch (e) {
      error({
        statusCode: e.statusCode,
        message: e.message
      })
    }
  },
}

